import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

        this.track = this.el.querySelector('[data-marquee="track"]');
        this.speed = 2;
        this.x = 0;
        this.raf = null;

        this.animate = this.animate.bind(this);
    }

    init() {
        if (!this.track) return;

        this.track.style.willChange = 'transform';
        this.raf = requestAnimationFrame(this.animate);
    }

    animate() {
        const firstGroup = this.track.querySelector('[data-marquee="group"]');
        if (!firstGroup) return;

        const firstGroupWidth = firstGroup.getBoundingClientRect().width;

        this.x -= this.speed;

        if (Math.abs(this.x) >= firstGroupWidth) {
            this.track.appendChild(firstGroup);
            this.x += firstGroupWidth;
        }

        this.track.style.transform = `translate3d(${this.x}px, 0, 0)`;
        this.raf = requestAnimationFrame(this.animate);
    }

    destroy() {
        if (this.raf) {
            cancelAnimationFrame(this.raf);
        }
    }
}